import { Model } from '@/models/Model';
export class Step extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Step';
        this.$endpoint = '/steps';
        this.$fillable = ['text', 'file'];
    }
    group(group) {
        if (typeof group !== 'string') {
            group = group.id || '';
        }
        this.$endpoint = '/groups/' + group + '/relationships/steps';
        return this;
    }
}
